<template>
    <div class="intersetPopu" v-if="InterDialogVisible">
        <el-dialog
            class="interset-dialog"
            title = ''
            width ="990px"
            height="524px"
            :modal-append-to-body="false"
            :lock-scroll="false"
            :visible.sync="InterDialogVisible"
            :before-close="handleClose">
            <div class="head">
                <h1>请选择你的学习兴趣</h1>                
                <span>至少选择一个，可随时调整</span>
            </div>
            <div class="interset-dialog-content">
                
                <el-tabs v-model="activeName">
                    <!-- <el-tab-pane label="产业与运营" name="fourth">定时任务补偿</el-tab-pane> -->
                    <el-tab-pane v-for="(item, index) in tagList" :key="item.parentcode" :label="item.codename" :name="'tab-'+ index">
                        <!-- 判断选中标签是否被包含 -->
                        <div class="template" v-for="(tag, tagindex) in item.codelist" :key="tagindex">
                            <el-button round @click="clickTag(tag)" :key="tag.code" type="primary" v-if="tag.primary && tag.primary === true">{{tag.name}}</el-button>
                            <el-button round @click="clickTag(tag)" :key="tag.code" v-else>{{tag.name}}</el-button>
                        </div>

                    </el-tab-pane>
                </el-tabs>
                
                <div class="br"></div>
                <div class="click-tag">
                    <div>
                        <span class="name">已选:{{number}}个</span>
                    </div>
                    <div>
                        <template v-for="tag in tagList">
                            <template v-for="item in tag.codelist">
                                <el-tag
                                    :key="item.parentcode"
                                    v-if="item.primary && item.primary == true"
                                    @close="clickTag(item)"
                                    closable>
                                    {{item.name}}
                                </el-tag>
                            </template>
                        </template>
                        
                    </div>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" round @click="submit">选好了</el-button>
                <span class="login" @click="loginPopu" v-if="!users.isLogin">已选过，登录账号 ></span>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getStudyInterestList, uploadStudyInterest} from 'api/course'
import {getIndexCategory} from 'api/indexApi'
import Cookies from 'js-cookie'
export default {
    name: 'intersetPopu',
    data() {
        return {
            InterDialogVisible: false,   // 弹窗展示
            tagList: [], // 标签列表
            activeName: 'tab-0', // 切换标签列表
            number: 0, //选中个数,
            users: this.user(), // 用户数据
            iswrite: 0, // 学习兴趣是否填写 0 未填写 1 填写
            oldTagList: [], // 旧的列表
        }
    },
    mounted() {
        // 是否已经填写列表
        this.getIndexCategory()
      
    },
    methods: {
        getIndexCategory() {
            getIndexCategory({
                data: {},
                success: data=> {
                    // let getIndexCategoryData = data.data.content // 获取推荐学习兴趣列表

                    this.iswrite = data.data.iswrite    // 是否选择学习兴趣

                    // console.log('iswrite', data.data)

                    // 未填写情况下触发
                    // if (this.iswrite !== 1) {
                        // 获取分类列表
                        this.setLoading(true)
                        getStudyInterestList({
                            data: {},
                            success: data => {
                                
                                let list = data.data.content,   // 取得学习兴趣列表
                                    selectedinfo = data.data.selectedinfo   // 取得选中的学习兴趣
                                for (let item in list) {
                                    for (let content in list[item].codelist) {
                                        list[item].codelist[content].primary = false // 默认选中分类为否
                                    }
                                }

                                // 登录情况下执行
                                if (this.users.isLogin == true) {
                                    
                                    this.number = 0 // 初始化数量

                                    // 填写了数据情况下，渲染选中列表数据
                                    // for (let i  = 0; i < getIndexCategoryData.length; i++) {    // 循环学习兴趣列表

                                    // 循环选中列表数据
                                    for (let item in selectedinfo) {

                                        // 循环学习兴趣列表大类
                                        for (let content in list) {
                                            // 循环小类别
                                            for(let type in list[content].codelist) {
                                                // 判断code是否相等
                                                if (selectedinfo[item].code == list[content].codelist[type].code) {
                                                    list[content].codelist[type].primary = true  // 增加选中分类
                                                    // console.log(selectedinfo[item].code +'=='+ list[content].codelist[type].code)
                                                    this.number ++
                                                }
                                            }

                                        }
                                    }
                                }
                                
                                this.$nextTick(() => {
                                    this.tagList = data.data.content
                                    // console.log('tagList', this.tagList)

                                })

                                this.setLoading(false)
                            },
                            error: data => {
                                this.setLoading(false)
                                this.$message.error(data)
                            }
                        })
                    // }

                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        loginPopu() {
            this.handleClose(0)
            this.setLoginPop(true)
        },
        submit() {  // 提交分类
            if (this.number === 0) {
                this.$message.error('请至少选择一个学习兴趣')
            } else {
                // 存储选中了的兴趣爱好
                // 未登录情况下，存储为本地Cookie，已经登录过则替换保存
                let codelist = {code: '', name: ''}

                 for (let item in this.tagList) {
                    for (let content in this.tagList[item].codelist) {
                        if (this.tagList[item].codelist[content].primary == true) {
                            codelist.code += this.tagList[item].codelist[content].code + ','
                            codelist.name += this.tagList[item].codelist[content].name + ','
                        }
                    }
                }
                let codelen = codelist.code.length,
                    namelen = codelist.name.length
                // 删除最后一个逗号（，）
                codelist.code = codelist.code.substring(0, codelen - 1)
                codelist.name = codelist.name.substring(0, namelen - 1)

                codelist = JSON.stringify(codelist)

                // 存储 兴趣爱好到 cookie中
                Cookies.set('codelist', codelist)

                // 登录情况下保存
                if(this.users.isLogin === true) {
                    this.setLoading(true)
                    uploadStudyInterest({
                        data: JSON.parse(Cookies.get('codelist')),
                        success: data => {
                            this.setLoading(false)
                            if (data.code == '000') {
                                this.$message.success('保存成功')
                            } else {
                                this.$message.success('保存失败')
                            }
                             // 关闭弹窗
                            this.handleClose(1)
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)

                             // 关闭弹窗
                            this.handleClose(0)
                        }
                    })
                } else {
                    // 关闭弹窗
                    this.handleClose(0)
                }
                
            }
        },
        handleClose(type) { // 关闭弹窗 传入参数 0 为保存失败或者未保存 还原初始数组    1 为成功，为新数组

            if (type !== 1) {
                this.tagList = JSON.parse(JSON.stringify(this.oldTagList))
            }
            Cookies.set('closeInteresPopu', 1, {expires: 1})  // 兴趣弹窗关闭后本次(一天内)不再弹出
            // sessionStorage.setItem('closeInteresPopu', 1)  

            this.$nextTick(() => {
                this.tagList = this.tagList
                this.num()
                this.InterDialogVisible = false
            })
        },
        num() { // 计算选择个数
            let list = this.tagList, 
            nums = 0
            for (let item in list) {
                for (let content in list[item].codelist) {
                    if (list[item].codelist[content].primary == true) {
                        nums ++  // 计算选择个数
                    }
                }
            }
            this.number = nums
        },
        startPopu() {   // 开启弹窗
            // let user = this.users
            // 未登录同时cookie不存在的情况下开启弹窗
            // if (user.isLogin === false && Cookies.get('codelist') == undefined) {
                
                // 存储一个过去数据的数组 用于后面数据还原
                // this.oldTagList = JSON.parse(JSON.stringify(this.tagList))
                // console.log(this.tagList)
                this.getIndexCategory()

                this.InterDialogVisible = true
            // }
        },
        submitCookie() {
            // 更新登录信息
            this.users = this.user()
            // 判断状态，登录状态下有cookie 同时未提交过cookie 情况下 提交cookie 
            if(this.users.isLogin === true && this.users.loginToken !== '' && Cookies.get('codelist') && this.iswrite !== 1) {
                uploadStudyInterest({
                    data: JSON.parse(Cookies.get('codelist')),
                    success: () => {
                        console.log('提交cookie')
                        // console.log(data)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }
            // console.log('登录发生了变化')
        },
        clickTag(tag) {    // 选中标签
           if (tag.primary && tag.primary == true) {
                tag.primary = false
                this.number --;
            } else {
                tag.primary = true
                this.number ++;
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
        ]),
        ...mapGetters(['user']),
    },
    computed: {
        userIsLogin() {
            return this.user().isLogin
        }
    },
    watch: {
        userIsLogin() {
            this.users =  this.user()
            this.$nextTick(() => {
                this.submitCookie()
            })
        }
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.interset-dialog {
    .el-dialog__body {
        padding: 30px 40px;
        .el-tag {
            font-size: 14px;
            border-radius: 30px;
        }
    }
    .head {
        span {
            padding-left: 20px;
            font-size:14px;
            color: #999;
        }
        h1 {
            display: inline-block;
            font-size:20px;
            font-weight:400;
        }
    }
    .interset-dialog-content {
        margin-top: 30px;

        .el-tabs {
            .template {
                display: inline-block;
            }
        }
        .el-tabs__header {
            margin: 0;
        }
        .el-tabs__item {
            font-size: 16px;
            color: #666;
        }
        .el-tabs__item.is-active {
            color: #409EFF;
        }
        .el-tabs__content {
            margin-left: -30px;
        }
        .el-button.is-round {
            margin-top: 20px;
            margin-right: 0;
            margin-left: 30px;
        }

        .br {
            margin-top: 20px;
            height: 1px;
            background: #E5E5E5;
        }

        .click-tag {
            margin-top: 20px;
            overflow: hidden;
           
           div {
               float: left;

               .name {
                   width: 80px;
                   margin-right: 10px;
                   line-height: 32px;
                   font-size: 14px;
                   color: #666;
               }

               &:last-child {
                   width: calc(100% - 100px)
               }
           }

           .el-tag {
               margin-right: 20px;
               margin-bottom: 10px;
           }
        }
        
    }
    .el-dialog__footer{
        text-align: center;
        padding-bottom: 40px;

        .el-button {
            width: 180px
        }
        .login {
            margin-left: 20px;
            cursor: pointer;
            color: #409EFF;
            font-size: 14px;
        }
    }
}
</style>